import { PlusOutlined } from '@ant-design/icons'
import { Button, Empty, Flex } from 'antd'
import React, { useEffect, useState } from 'react'
import { useRecoilState } from 'recoil'
import Swal from 'sweetalert2'
import {
  getFastLaneDetail,
  getFastLaneList,
  updateFastLaneStatus,
} from '../../api/aopsFastLane.api'
import FastLaneCard from '../../components/apos/fastLane/FastLaneCard'
import FastLaneModal from '../../components/apos/fastLane/FastLaneModal'
import SectionHeader from '../../components/apos/SectionHeader'
import { userState } from '../../store/user'
import './fastLaneBoard.scss'
const FastLaneBoard = ({
  onReloadInitData,
  setFastLaneList,
  fastLaneList,
  userId,
  myId,
}) => {
  const [user] = useRecoilState(userState)
  const [isModalOpen, setIsModalOpen] = useState(false)
  // const [fastLaneList, setFastLaneList] = useState([])
  const [fastLaneDetail, setFastLaneDetail] = useState(null)
  const openErrorModal = (error) => {
    Swal.fire({
      customClass: { popup: 'custom-alert' },
      icon: 'error',
      title: '에러 발생',
      text: error.response.data.detail[1].description,
    })
  }

  useEffect(() => {
    if (userId) fetchFastLaneList()
  }, [userId])
  const fetchFastLaneList = async () => {
    try {
      const res = await getFastLaneList(userId, 'FASTLANE_WORK')
      const data = res?.slice(0, 100) || []
      setFastLaneList(data)
    } catch (error) {
      console.log(error)
      setFastLaneList([])
      openErrorModal(error)
    }
  }

  const sortedData = fastLaneList.sort((a, b) => {
    // 1️⃣ isComplete가 false인 것이 우선
    if (a.isComplete !== b.isComplete) {
      return a.isComplete ? 1 : -1
    }

    // 2️⃣ dueDateTime 최신순 정렬
    return new Date(b.dueDateTime) - new Date(a.dueDateTime)
  })

  const handleSwitchComplete = async (workId, isComplete) => {
    try {
      const res = await updateFastLaneStatus(workId, {
        isComplete: !isComplete,
      })
      fetchFastLaneList()
      onReloadInitData()
    } catch (error) {
      console.log(error)
      openErrorModal(error)
    }
  }

  const handleClickDetail = async (workId) => {
    try {
      const res = await getFastLaneDetail(workId)
      // console.log(res)
      setFastLaneDetail(res)
      setIsModalOpen(true)
    } catch (error) {
      console.log(error)
      openErrorModal(error)
    }
  }

  useEffect(() => {
    if (!isModalOpen) {
      setFastLaneDetail(null)
    }
  }, [isModalOpen])
  return (
    <>
      <div className="fast-lane-board">
        <SectionHeader
          title="패스트레인 보드"
          subtitle="지금 가장 빨리 처리해야 할 일을 바로 파악할 수 있어요"
          // buttonText={'Fast 업무 생성'}
          // onButtonClick={() => setIsModalOpen(true)}
        />
        <div className={'fast-lane-board-content'}>
          <div className={'content-header'}>
            <Flex gap={8} align="center" justify="space-between">
              <div>
                <p className={'content-header-title'}>업무 현황</p>

                <Flex gap={8} align="center">
                  <Flex gap={4}>
                    <span className={'text-title'}>예정</span>
                    <span className={'text-count'}>
                      {fastLaneList?.filter((item) => !item.isComplete).length}
                    </span>
                  </Flex>
                  <div className={'text-divider'} />
                  <Flex gap={4}>
                    <span className={'text-title'}>완료</span>
                    <span className={'text-count'}>
                      {fastLaneList?.filter((item) => item.isComplete).length}
                    </span>
                  </Flex>
                </Flex>
              </div>
              {userId === myId && (
                <Button
                  type="default"
                  onClick={() => setIsModalOpen(true)}
                  className={'register-fast-button'}
                >
                  Fast 업무 생성
                  <PlusOutlined />
                </Button>
              )}
            </Flex>
          </div>
          {/* {console.log(sortedData, 'sortedData')} */}
          <div className={'fast-lane-card-list'}>
            {sortedData.map((item) => (
              <FastLaneCard
                key={item.workId}
                {...item}
                onClickSwitchComplete={() =>
                  handleSwitchComplete(item.workId, item.isComplete)
                }
                onClickDetail={() => handleClickDetail(item.workId)}
                // openErrorModal={openErrorModal}
              />
            ))}
            {fastLaneList.length === 0 && (
              <div className={'empty-list no-shadow'}>
                <Empty description="패스트 업무가 없습니다." />
              </div>
            )}
          </div>
        </div>
      </div>
      <FastLaneModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={fastLaneDetail ? 'FastLane 업무 상세' : 'FastLane 업무 생성하기'}
        fastLaneDetail={fastLaneDetail}
        fetchFastLaneList={fetchFastLaneList}
        onReloadInitData={onReloadInitData}
      />
    </>
  )
}

export default FastLaneBoard
